import React from 'react'

const PassengerSide = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 960 716" xmlSpace="preserve" width={width} height={height}>
    <polyline
      fill="none"
      stroke={color}
      strokeWidth="18.703"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      points="
	942,162.234 942,432.76 800.725,537.965 "
    />
    <polyline
      fill="none"
      stroke={color}
      strokeWidth="18.703"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      points="
	677.485,580.047 16.198,360.62 16.198,141.193 "
    />
    <ellipse transform="matrix(0.9676 -0.2524 0.2524 0.9676 -87.9529 149.339)" fill="none" stroke={color} strokeWidth="9.3515" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="538.035" cy="417.444" rx="72.897" ry="92.744" />
    <ellipse transform="matrix(0.9839 -0.179 0.179 0.9839 -53.6768 23.9669)" fill="none" stroke={color} strokeWidth="9.3515" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="105.988" cy="309.465" rx="29.456" ry="60.646" />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M870.194,254.423c0,0,35.687,21.375,44.939,54.773c9.252,33.398,0,72.14-1.322,77.484c-1.322,5.344,1.322,21.375-2.643,29.391
	c-3.965,8.016-60.8,61.453-126.888,72.14c-66.087,10.687-148.036-9.352-148.036-9.352s34.056-150.989-99.131-175.007
	c-79.635-14.361-104.418,84.164-93.844,117.562c-33.044-8.016-252.454-73.476-266.993-77.484
	c-14.539-4.008-23.791-10.687-25.113-24.047c-1.322-13.359-9.252-78.82-51.548-88.172c-26.336-5.823-41.331,26.719-36.044,65.461
	c0,0-43.261-30.726-15.504-120.234c0,0,6.609-12.023,22.47-16.031"
    />
  </svg>
)
export default PassengerSide
